import { ProductionQueueStats, ProductionState } from './types';

export const getters = {
	queue: (state: ProductionState) => state.queue.data,

	queueMeta: (state: ProductionState) => state.queue.meta,

	currentQueueItem: (state: ProductionState) => state.currentQueueItem,

	products: (state: ProductionState) => state.products,

	materials: (state: ProductionState) => state.materials,

	plannedMaterials: (state: ProductionState) => state.plannedMaterials,
	plannedMaterialsByProduct: (state: ProductionState) => state.plannedMaterialsByProduct,

	materialUsage: (state: ProductionState) => state.materialUsage,
	materialComparisonByProduct: (state: ProductionState) => state.materialComparisonByProduct,

	internalProducts: (state: ProductionState) => state.products.filter(p => p.isInternal),

	externalProducts: (state: ProductionState) => state.products.filter(p => !p.isInternal),

	productsBySku: (state: ProductionState) => (sku: string) =>
		state.products.find(p => p.sku === sku),

	suppliers: (state: ProductionState) => state.suppliers,

	productionStages: (state: ProductionState) => state.productionStages,

	users: (state: ProductionState) => state.users,

	timeline: (state: ProductionState) => state.timeline,

	activeFilters: (state: ProductionState) => state.activeFilters,

	loading: (state: ProductionState) => state.loading,

	error: (state: ProductionState) => state.error,

	auxiliaryComponents: (state: ProductionState) => state.auxiliaryComponents,

	// Statistics
  queueStats: (state: ProductionState): ProductionQueueStats => {
    const stats = state.queue.meta?.stats;

    return {
      total: stats?.total ?? 0,
      pending: stats?.pending ?? 0,
      inProgress: stats?.in_progress ?? 0,
      paused: stats?.paused ?? 0,
      completed: stats?.completed ?? 0,
      overdue: stats?.overdue ?? 0,
    };
  },

	queueItemById: (state: ProductionState) => (id: number) =>
		state.queue.data.find(item => item.id === id),

	// Reports getters
	efficiencyReport: (state: ProductionState) => state.reports.efficiency,
	timeAnalysisReport: (state: ProductionState) => state.reports.timeAnalysis,
	costAnalysisReport: (state: ProductionState) => state.reports.costAnalysis,
	statusOverviewReport: (state: ProductionState) => state.reports.statusOverview,
	reportsLoading: (state: ProductionState) => state.reports.loading,
	reportsError: (state: ProductionState) => state.reports.error,
};

export default getters;
